import { useEffect } from 'react';

import { experiments } from '../../experiments';

export const useInitialReferralFromUrl = () => {
  useEffect(() => {
    if (!experiments.is('specs.chatbot.articlesSideView', 'true')) {
      return;
    }
    const referralFromUrl = new URLSearchParams(window.location.search).get('referral');
    if (referralFromUrl) {
      sessionStorage.setItem('referral', referralFromUrl);
    }
  }, []);
};
